export const MONOGO_DB_CONFIG = {
    credentialType: "DIY",
    conditionToConnect: true,
    shouldListeningStartFromMongo: true,
    getInitialData: false,
    operationType: ["insert", "update", "modify"]
};
